var randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
export default {
  randomUUID
};


// WEBPACK FOOTER //
// ./~/uuid/dist/esm-browser/native.js